/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal } from '@gerdau/hefesto';
import { ERoutes } from '../../../../routes';
import { ApplicationState } from '../../../../store';
import { updateLongSteelShoppingCartSettings } from '../../../../store/ducks/long-steel-shopping-cart/actions';
import { ILongSteelOrderItem } from '../../../../store/ducks/long-steel-shopping-cart/types';
import { EPurchaseRoutes } from '../../purchase.routes';
import OrderSettingsConfig from './OrderSettingsConfig';
import OrderSettingsRoutes, {
  EOrderSettingsRoutes
} from './orderSettings.routes';
import { Container } from './styles';
import moment from 'moment';
import {
  isOutOfMinimunDate,
  isWeekend
} from './ShoppingCartTable/shoppingCartFieldsValidation';
import SearchedListMvp from './SearchedListMvp';
import LoadingItems from './LoadingItems';
import { useCart } from '../ShoppingCartMVP/useCart';
import { ICustomer } from '../../../../store/ducks/customers/types';
import { useCartService } from '../../../../services/MVP/useCartService';
import { updateCartItemsQuantity } from '../../../../store/ducks/cart-items-mvp/actions';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';

const OrderSettingsMvp: React.FC = () => {
  const { createNewCart } = useCartService();
  const { cartData, cartId, deleteCartId } = useCart();
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const [orderModalStatus, setOrderModalStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp
  ).quantity;

  const customer = customersState.customers.find(
    (customer) => customer.customerId === shoppingCartState.emitterId
  ) as ICustomer;

  const handleUpdateQuantity = (qty: number) => {
    dispatch(updateCartItemsQuantity(qty));
  };

  const canShowOrderSettingsConfig =
    !pathname.includes(EOrderSettingsRoutes.CHECKOUT) &&
    !pathname.includes(EOrderSettingsRoutes.CHOOSE) &&
    !pathname.includes(EOrderSettingsRoutes.FINALIZE_ORDER);

  const onRemoveItem = (idxsToRemove: number[]) => {
    const updatedItems = shoppingCartState.items.filter(
      (_, index) => !idxsToRemove.includes(index)
    );
    dispatch(
      updateLongSteelShoppingCartSettings({
        ...shoppingCartState,
        items: updatedItems
      })
    );
  };

  const onUpdateCartItem = () => {
    setCanGoToConfirmOrder(getCanGoToConfirmOrder());
  };

  const customerLoading =
    customersState.loading ||
    !!customersState.loadingPurchaseReceivers ||
    !!customersState.loadingBlocks ||
    !!customersState.loadingCustomerById ||
    !!customersState.loadingProductDescription ||
    !!customersState.loadingPurchaseReceivers;

  const getCanGoToConfirmOrder = (): boolean => {
    return (
      shoppingCartState.receiverId !== '' &&
      !customersState.loading &&
      customersState.loadingPurchaseReceivers === false &&
      customersState.loadingProductDescription === false &&
      customersState.loadingBlocks === false &&
      !shoppingCartState.items.some(
        (item) =>
          !item.itemSaleInfo?.unityMeasure ||
          !isAvalidQuantity(item) ||
          !isAvalidDate(item) ||
          !item.itemSaleInfo.term ||
          (item.itemSaleInfo.customerPurchaseItem &&
            item.itemSaleInfo.customerPurchaseItem.length > 6)
      )
    );
  };

  const isAvalidQuantity = (item: ILongSteelOrderItem): boolean => {
    const value = item.itemSaleInfo.quantity;
    const measureUnit = item.destinations[0].measureUnits.find(
      (unit) => unit.measure === item.itemSaleInfo.unityMeasure
    );
    return (
      value !== undefined &&
      Number(value) !== 0 &&
      measureUnit !== undefined &&
      parseFloat(measureUnit.minimumQuantity) <= parseFloat(value) &&
      Math.round(parseFloat(value) * 1000) %
        Math.round(parseFloat(measureUnit.multiple) * 1000) ===
        0
    );
  };

  const isAvalidDate = (item: ILongSteelOrderItem): boolean => {
    const value = item.itemSaleInfo.requiredDate;
    return (
      !isOutOfMinimunDate(item.destinations[0].minimumDate, value) &&
      !isWeekend(moment(value, 'YYYY-MM-DD'))
    );
  };

  const { commerceScreenName = '' } = getTaggingInformationScreen(
    history.location.pathname
  );
  const handleTaggingContinueLastOrder = (
    navigationButton: 'novo_pedido' | 'continuar_pedido'
  ) => {
    dispatch(
      sendTagging({
        event: 'continuar_ultimo_pedido',
        screenName: commerceScreenName,
        etapa: commerceScreenName,
        botao_navegacao: navigationButton
      })
    );
  };

  const [canGoToConfirmOrder, setCanGoToConfirmOrder] = useState(
    getCanGoToConfirmOrder()
  );

  const onConfirmClick = () => {
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${EOrderSettingsRoutes.CHECKOUT}`
    );
  };

  useEffect(() => {
    if (shoppingCartState.items.length > 0) {
      // atualizar o totalizador, quando adicionar item via planiha que tenha algum valor
      onUpdateCartItem();
    }
  });

  useEffect(() => {
    const loadCart = async () => {
      if (
        !customerLoading &&
        customer?.productsDescriptionResponse &&
        canShowOrderSettingsConfig &&
        !pathname.includes(EOrderSettingsRoutes.SHOPPING_CART) &&
        shoppingCartState.emitterId !== '' &&
        shoppingCartState.receiverId !== ''
      ) {
        const data = await createNewCart(
          shoppingCartState.emitterId,
          shoppingCartState.receiverId,
          undefined,
          true
        );
        if (data?.alreadyCart) {
          setOrderModalStatus(true);
        }
      }
    };

    loadCart();
  }, [shoppingCartState.emitterId, shoppingCartState.receiverId]);

  const handleOrderModal = async (option?: 'continuous' | 'new') => {
    if (option === 'new') {
      handleUpdateQuantity(0);
      deleteCartId();
      handleTaggingContinueLastOrder('novo_pedido');
      // sessionStorage.setItem('ordercontinuos', 'true');
      return setOrderModalStatus(false);
    }

    if (option === 'continuous') {
      setOrderModalStatus(false);
      handleTaggingContinueLastOrder('continuar_pedido');
    }

    // sessionStorage.setItem('ordercontinuos', 'true');
    setOrderModalStatus(false);
  };

  const emitterDisabled =
    pathname.includes(EOrderSettingsRoutes.SHOPPING_CART) ||
    (!!cartId && cartQuantity > 0) ||
    customerLoading;

  return (
    <Container>
      {canShowOrderSettingsConfig && (
        <OrderSettingsConfig emitterDisabled={emitterDisabled} />
      )}

      {orderModalStatus && (
        <Modal
          title="Continuar seu último pedido?"
          buttons={{
            left: {
              name: 'Novo pedido',
              children: 'Novo pedido',
              onClick: () => handleOrderModal('new'),
              loading
            },
            right: {
              name: 'Continuar pedido',
              children: 'Continuar pedido',
              onClick: () => handleOrderModal('continuous'),
              disabled: loading
            }
          }}
          modalSize="sm"
        >
          Você possui um pedido em andamento. Deseja continuar a partir dele?
        </Modal>
      )}

      <OrderSettingsRoutes />
    </Container>
  );
};

export default OrderSettingsMvp;
